import {Button} from 'antd'
import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default function PropertiesPaneButtonGenerateRam(props) {
    const map = useMapContext()
    const {prjId, sVer} = map.data
    const selectedNodes = map.useSelectedNodes()

    const nodes = [...selectedNodes].filter(n => {
        const {pkid, prjId: _prjId, sVer: _sVer} = n.data

        return (
            pkid &&
            _prjId === prjId &&
            _sVer === sVer
        )
    })

    if (0 === nodes.length) {
        return null
    }

    const onClick = () => {
        const bdIds = []
        const bdNames = []

        for (const n of nodes) {
            const {bdName, pkid} = n.data
            bdIds.push(pkid)
            bdNames.push(bdName)
        }

        openWindow(
            '/Ai',

            {
                bizMap: {bdIds},
                prjId,
                scene: 'GENERATE_RAM',
                sVer,
                title: `程序模块: ${bdNames.join(', ')}`,
            }
        )
    }

    return (
        <Button
            onClick={onClick}
            {...props}
        >
            AI分析建模
        </Button>
    )
}
